import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { get } from 'lodash';
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Input155px } from '../../../styles/inputGroup';
import Card from '../../../components/card';
import Loading from '../../loading';

import { displayErrors } from '../../../util/diversos';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';

export default function RelatorioClienteAniversariante() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);

  const [listaEmpresas, setListaEmpresas] = useState([]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 99999,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  function headRows() {
    return [
      { dataNascimento: 'Dia', razaoSocial: 'Nome / Razão Social', telefone: 'Telefone' },
    ];
  }

  const [headerTabelaImpressao] = useState(headRows());

  const idUsuario = get(store.getState().auth.user, 'id', 0);

  async function getData(searchFilter, page, size, img) {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();
    try {
      setIsLoading(true);

      if (findDataInicial == null && findDataFinal == null) {
        toast.info('Datas devem ser informadas.');
        return;
      }

      if (findDataInicial > findDataFinal) {
        toast.info('Data final anterior a data inicial.');
        return;
      }

      let params = `/participante/buscaaniversariante?idUsuario=${idUsuario}`;

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')}`;
        const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')}`;

        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      const response = await axiosAdmin.get(params);

      if (response.data.length <= 0) {
        toast.info('Não há registros a serem exibidos.');
        return;
      }

      let data = {
        dataNascimento: '',
        razaoSocial: '',
        telefone: '',
      };

      const result = [];
      for (let x = 0; x < response.data.length; x++) {
        const cliente = response.data[x];

        data = {
          dataNascimento: dateFormat(cliente.dataNascimento, 'dd/mm'),
          razaoSocial: cliente.razaoSocial,
          telefone: cliente.telefone_1 ? cliente.telefone_1 : '',
        };

        result.push({ ...data });
      }

      data = {
        dataNascimento: '',
        razaoSocial: '',
        telefone: '',
      };

      result.push({ ...data });

      doc.autoTable({
        styles: {
          fontSize: 8,
        },
        margin: { top: 38, left: 5, right: 5 },
        columnStyles: {
          1: { cellWidth: 150 },
        },
        theme: 'grid',
        head: headerTabelaImpressao,
        body: result,
        didDrawPage: dados => {
          // Header
          doc.rect(5, 5, 200, 30);
          doc.addImage(img, 'JPEG', 9, 8, 25, 25);
          doc.setFontSize(20);
          doc.text('Relatório de Aniversariantes', 65, 15);

          doc.setFontSize(8);
          doc.text('Período:', 50, 32);
          doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
          doc.text(' à ', 79, 32);
          doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);

          // colocar a empresa destino se houver

          // footer
          const { pageSize } = doc.internal;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
          doc.text('Elo Informática Barbacena LTDA', 82, pageHeight - 8);
          const periodo = new Date();
          doc.text('Impresso: ', 172, pageHeight - 8);
          // eslint-disable-next-line prefer-template
          doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 189, pageHeight - 8);
        },
      });
      window.open(doc.output('bloburl'));
    } catch (e) {
      // console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setFindDataInicial(new Date(store.getState().auth.consultaEstampariaPedidoDataInicial));
    setFindDataFinal(new Date(store.getState().auth.consultaEstampariaPedidoDataFinal));
  }, []);

  useEffect(() => {
    async function verificarSeMultiEmpresa() {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        const response = await axiosAdmin.get(params);

        const _listaEmpresas = get(response.data, 'listaEmpresas', []);

        const listDropdown = [{
          label: 'Todos',
          value: 'TODOS',
          id: 0,
        }];

        _listaEmpresas.forEach(element => {
          listDropdown.push(
            {
              label: element.razaoSocial,
              value: element.cnpj,
              id: element.id,
            });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaEmpresas(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    verificarSeMultiEmpresa();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal};

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    const loadImage = async () => {
      let config = '';
      try {
        config = await axiosAdmin.get(`/configuracaosistema?idUsuario=${idUsuario}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }

      const img = new Image();
      img.src = `/logotipos/${config.data.urlLogotipo}`;

      await img.decode().then(() => {
      }).catch(() => {
        img.src = 'logo.png';
      });
      getData(searchFilter, 0, lazyParams.rows, img);
    };
    loadImage();
    // getData(searchFilter, 0, lazyParams.rows);
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}> Relatório de Aniversariantes </h6>
        </div>

        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Mês Inicial
              </Input155px>
              <style>
                {`
                  /* Este CSS só afetará elementos dentro de
                    .meu-calendario-com-estilo-interno */
                  .p-datepicker-header {
                      display: none !important; /* Oculta o elemento do ano */
                  }

                  .p-datepicker-buttonbar {
                      display: none !important; /* Oculta o elemento do ano */
                  }
                `}
              </style>
              <Calendar
                id="mask"
                showIcon
                view="month"
                mask="99"
                dateFormat="mm"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataInicial}
                onChange={(e) => setFindDataInicial(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup meu-calendario-especifico">
              <Input155px className="p-inputgroup-addon">
                Mês Final
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99"
                view="month"
                dateFormat="mm"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataFinal}
                onChange={(e) => setFindDataFinal(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-5">

          </div>
          <div className="col-lg-1 text-end">
            <button
              type="button"
              title="Imprimir Relatório"
              className="btn btn-success"
              style={{ borderRadius: '15px' }}
              onClick={handleFind}
            >
              <i className="pi pi-print"></i>
            </button>
          </div>
        </div>
      </Card>
    </>
  );
}
